// Cocoon instantiation of the shared account order-detail `.order-summary`
// render. The shared createOrderDetail factory (tsi-common-react) owns the
// markup; this module injects cocoon's own OrderOffer component (site-specific
// SCSS/layout, imports from the cocoon Checkout tree). Kept distinct from the
// cocoon thank-you `components/OrderDetail`, which is a separate confirmation
// component.
import { createOrderDetail } from "tsi-common-react/src/apps/customer-account/OrderDetail/index";

import { OrderOffer } from "../../apps/checkout/OrderOffer";

export const AccountOrderDetail = createOrderDetail({ OrderOffer });
